module.exports = __webpack_public_path__ + "static/img/ic-tec-logo-spark.d62aebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-tec-logo-spark.png
// module id = 8jMo
// module chunks = 1